export enum EvergageActions {
  HOME_PAGE_VIEW = "Home page view",
  NEWSLETTER_SUBSCRIBED = "Newsletter Subscribed",
  CLP_VIEW = "CLP View",
  PLP_VIEW = "PLP View",
  PDP_VIEW = "PDP View",
  RBP_VIEW = "RBP View",
  SHARED_CATALOG_OBJECT = "Share Catalog Object",
  REGISTRATION_SUCCESSFUL = "Account Registration Successful",
  ADD_TO_SHOPPING_LIST = "Add to Wishlist",
  REMOVE_FROM_SHOPPING_LIST = "Remove from Wishlist",
  SEARCH_LOCATION = "Search Location",
  SELECT_SIZE = "Select Size",
  VIEW_ARTICLE = "Article View",
  VIEW_SHOPPING_LIST = "Shopping List View",
  NEWSLETTER_SUBSCRIBE = "Profile subscription",
  NEWSLETTER_UNSUBSCRIBE = "Profile unsubscribe",
  SELECT_QUANTITY = "Select Quantity",
  REMOVE_FROM_CART = "Remove From Cart",
  SELECTED_STORE = "Selected Store",
  CHANGE_SIZE = "Change size",
  VIEW_ITEM_OUT_OF_STOCK = "View Item Out of Stock",
  SELECT_OUT_OF_STOCK_SIZE = "Select Out Of Stock Size",
  VIEW_CART = "View Cart",
  ADD_TO_CART = "Add To Cart",
  COMING_SOON = "Coming Soon Registration",
  ACCOUNT_VIEW = "Account View",
  NEWSLETTER_VIEW = "Newsletter View",
  LOGIN_VIEW = "Login View",
}

export enum EvergageItemActions {
  ADD_TO_CART = "Add To Cart",
  VIEW_ITEM_OUT_OF_STOCK = "View Item Out Of Stock",
  QUICK_VIEW_ITEM = "Quick View Item",
  STOP_QUICK_VIEW_ITEM = "Stop Quick View Item",
  VIEW_CATEGORY = "View Category",
  VIEW_CART = "View Cart",
  FAVORITE = "Favorite",
  UPDATE_LINE_ITEM = "Update Line Item",
  REMOVE_FROM_CART = "Remove From Cart",
  CHANGE_CART_URL = "Change cart URL",
  VIEW_ITEM = "View Item",
}

export enum EvergageCatalogObjects {
  CATEGRIES_AND_COLLABS = "Category",
  BRAND = "BRAND",
  GENDER = "Gender",
  PRICE_RANGE = "PriceRange",
  SIZE = "Size",
  STORE = "Store",
  COLOR = "Style",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  STYLE = "ItemClass",
}
